import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { ContentCard } from '../Cards';
import { connect } from 'react-redux';
import { fetchGetDocumentBlobForGroup, fetchGetDocumentsForGroup, fetchGetDocumentBlobForGroupAsBlob } from '../../actions/DocumentActions';
import PropTypes from 'prop-types';
import { FaDownload, FaEye } from 'react-icons/fa';
import DocumentViewer from '../DocumentViewer/DocumentViewer';
import { addNotificationToApp } from '../../actions/NotificationsActions';
import { Table, ButtonGroup, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import nextId from 'react-id-generator';

class PlanDocuments extends Component {
    state = {
        loadingDocument: false,
        showPDFModal: false,
        currentDocumentName: "",
        currentDocumentBlob: "",
        planDocuments: [],
        arePlanDocumentsLoading: false
    };
    _mounted = false;

    getDocumentBlob = (groupId, document) => {
        if(this._mounted){
            this.setState({loadingDocument: true}, () => {
                this.props.getDocumentBlob(groupId, document.documentId)
                    .then((results) => {
                        if(this._mounted){
                            this.setState({
                                currentDocumentName: document.fileName,
                                currentDocumentBlob: results,
                                showPDFModal: true,
                                loadingDocument: false
                            });
                        }
                    });
            });
        }
    };

    togglePDFModal = () => {
        const showPDFModal = this.state.showPDFModal;
        if(this._mounted){
            this.setState({
                showPDFModal: !showPDFModal
            });
        }
    };

    async componentDidMount() {
        this._mounted = true;
        this.getGroupDocuments();
    }

    componentWillUnmount(){
        this._mounted = false;
    }

    getGroupDocuments = async () => {
        const { groupId, availablePlans, addNotificationToApp } = this.props;
        const planTypeId = this.props.match.params.planTypeId;
        if(!availablePlans || !availablePlans.length) {
            return;
        }

        if(this._mounted){
            this.setState({
                arePlanDocumentsLoading: true
            });
        }

        try {
            // Queue up all plan design fetches in parallel.
            const documentFetchPromiseList = [];
            availablePlans.forEach(plan => {
                if (plan.planTypeId === parseInt(planTypeId, 10)) {
                    // only make this call when plan type matches current location, prevents getting docs again on departure.
                    documentFetchPromiseList.push(fetchGetDocumentsForGroup(groupId, plan.groupPlanDesignId));
                }
            });

            // Wait for all documents to finish loading.
            const allDocumentsResultArray = await Promise.all(documentFetchPromiseList);

            // Join all results together into a single flat array instead of an array of arrays.
            const nonUniqueResults = [].concat.apply([], allDocumentsResultArray);

            // Get unique documents from the whole set. (It's valid we might get back the same document multiple times across several plan designs.)
            const seenDocumentIds = {};
            const uniqueDocuments = nonUniqueResults.filter(document => {
                const documentId = document.documentId;

                return Object.prototype.hasOwnProperty.call(seenDocumentIds, documentId) ? false : (seenDocumentIds[documentId] = true);
            });
            
            // Also, sort alphabetically by file name.
            uniqueDocuments.sort((a, b) => {
                if(a.fileName < b.fileName)
                    return -1;
                if (a.fileName > b.fileName)
                    return 1;
                return 0;
            });

            if(this._mounted){
                this.setState({
                    planDocuments: uniqueDocuments
                });
            }
        }
        catch(err) {
            addNotificationToApp('Error Fetching Plan Documents', 'danger');
        } 
        finally {
            if(this._mounted){
                this.setState({
                    arePlanDocumentsLoading: false
                });
            }
        }
    };



    renderPlanDocuments = planDocuments => {
        const result = planDocuments.map((document, index) => {
            return (
                <tr key={`pd-${index}`}>
                    <td>
                        {document.fileName}
                    </td>
                    <td>
                        <ButtonGroup>
                            <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip id={nextId()}> View </Tooltip>}
                            >
                                <Button variant="outline-success" size="sm" aria-label="View Document"onClick={() => this.getDocumentBlob(this.props.groupId, document)}>
                                    <FaEye />
                                </Button>
                            </OverlayTrigger>

                            <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip id={nextId()}> Download </Tooltip>}
                            >
                                <Button variant="outline-primary" size="sm" aria-label="Download Document"onClick={() => this.props.downloadGroupDocument(this.props.groupId, document.documentId)}>
                                    <FaDownload />
                                </Button>
                            </OverlayTrigger>
                        </ButtonGroup>
                    </td>
                </tr>
            );
        });

        if (result.length === 0) {
        result.push(
            <tr key={`pd-empty`}>
                <td colSpan={2}>
                    No Documents Found
                </td>
            </tr>
        );
        }

        return result;
    };

    render() {
        const { showPDFModal, currentDocumentBlob, currentDocumentName, planDocuments, arePlanDocumentsLoading } = this.state;
        return (
            <React.Fragment>
                <DocumentViewer toggleModal={this.togglePDFModal} showModal={showPDFModal} fileName={currentDocumentName} blob={currentDocumentBlob} />
                <ContentCard loading={arePlanDocumentsLoading} >
                    <h2>Documents</h2>
                    <Table striped size="sm">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>                           
                            {this.renderPlanDocuments(planDocuments)}             
                        </tbody>
                    </Table>
                </ContentCard>
            </React.Fragment>
        );
    }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => {
    return {
        addNotificationToApp: (message, type) => {
            dispatch(addNotificationToApp(message, type));
        },
        downloadGroupDocument: (groupId, documentId) =>{
            return dispatch(fetchGetDocumentBlobForGroup(groupId, documentId));
        },
        getDocumentBlob: (groupId, documentId) => {
            return dispatch(fetchGetDocumentBlobForGroupAsBlob(groupId, documentId));
        }
    };
};

PlanDocuments.propTypes = {
    availablePlans: PropTypes.any
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PlanDocuments));